import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { from, Observable, switchMap } from 'rxjs';
import { environment } from '../environments/environment';
import { UserService } from './user.service';
import { ReplayProtectionService } from './replay-protection.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private apiUrl = environment.apiUrl;

  private token: string;
  constructor(private http: HttpClient, private userService: UserService, private replayProtection: ReplayProtectionService) {
    this.token = this.userService.getAccessToken();
  }

  validateUser(username: string, password: string): Observable<HttpResponse<any>> {
    const body = { username: username, password: password };
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${this.token}` });
    const url = `${this.apiUrl}/api/Auth/ValidateUser`;
    return this.http.post(url, body, { headers: headers, observe: 'response' });
  }

  ValidateUserRedirection(Token: string, LoginType: number): Observable<HttpResponse<any>> {
    const body = { token: Token, loginType: LoginType };
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${this.token}` });
    const url = `${this.apiUrl}/api/Auth/validateUserRedirection`;
    return this.http.post(url, body, { headers: headers, observe: 'response' });
  }

  LogoutJTIUpdate(token: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({ 'Authorization': `Bearer ${token}` });
    const url = `${this.apiUrl}/api/Auth/LogoutJTIUpdate`;
    return this.http.post(url, { jwttoken: token }, { headers: headers, observe: 'response' });
  }

  ChangePassword(userId: number, password: string, oldPassword: string): Observable<HttpResponse<any>> {
    const body = { userId, password, oldPassword };
    const url = `${this.apiUrl}/api/User/ChangePassword`;
    return from(
      this.replayProtection.getHeaders(body, 'ChangePassword', String(this.userService.getUserId()))
    ).pipe(
      switchMap(replayHeaders => {
        const headers = new HttpHeaders({ 'Authorization': `Bearer ${this.userService.getAccessToken()}`, ...replayHeaders });
        return this.http.post(url, body, { headers, observe: 'response' });
      })
    );
  }
}
